import React from 'react';
import './Email.css'

const Email = () => {
    return (
        <>
            <div className='max-w-[1400px] mx-auto hidden md:inline-block' >
                <a href="mailto:18aishaahmad@gmail.com" className='email-a transition-styles font-semibold' data-aos="fade-up" >18aishaahmad@gmail.com</a>
            </div>
        </>
    );
};

export default Email;